/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PublishReviewDecisionRequest
 */
export interface PublishReviewDecisionRequest {
    /**
     * 
     * @type {string}
     * @memberof PublishReviewDecisionRequest
     */
    comment?: string;
}

/**
 * Check if a given object implements the PublishReviewDecisionRequest interface.
 */
export function instanceOfPublishReviewDecisionRequest(value: object): value is PublishReviewDecisionRequest {
    return true;
}

export function PublishReviewDecisionRequestFromJSON(json: any): PublishReviewDecisionRequest {
    return PublishReviewDecisionRequestFromJSONTyped(json, false);
}

export function PublishReviewDecisionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublishReviewDecisionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}

export function PublishReviewDecisionRequestToJSON(json: any): PublishReviewDecisionRequest {
    return PublishReviewDecisionRequestToJSONTyped(json, false);
}

export function PublishReviewDecisionRequestToJSONTyped(value?: PublishReviewDecisionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'comment': value['comment'],
    };
}

